import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
// 导入字体图标
import './assets/fonts/iconfont.css'
// 导入全局样式表
import './assets/css/global.css'
// 导入全局mixin
import BaseMixin from "@/mixins/base-mixin"
Vue.mixin(BaseMixin)
//全局自定义指令，权限设置
import Dclrights from './plugins/directives.js'
Vue.use(Dclrights)
// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'
// Vue.use(VideoPlayer)
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)


//动画
import animated from 'animate.css' // npm install animate.css --save安装，在引入
Vue.use(animated)

//百度地图api
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'pw5b4tvdTZcH7jW8VvOAIAahggzY63kw'
})


//打印依赖
import Print from 'vue-print-nb'
Vue.use(Print)
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
// 使用vue-lazylocad,图片懒加载
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('../src/assets/img/error.png'),
  loading: require('../src/assets/img/load.gif'),
  attempt: 1
})



//导入全局moment格式化时间
import moment from 'moment'
//统一接口api文件夹里面全部请求函数
import * as API from './api';

Vue.prototype.$http = API
Vue.config.productionTip = false
Vue.filter('fmtdate',function(v){
	return moment(v).format('yyyy-MM-DD HH:mm:ss')
})

//swiper轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper /* { default options with global component } */)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
